module.exports = __webpack_public_path__ + "img/edit.5b992c5e.svg";